'use client'

import cn from 'classnames'
import React, { forwardRef, useRef, ButtonHTMLAttributes } from 'react'
import { mergeRefs } from 'react-merge-refs'

import LoadingDots from '@/components/ui/LoadingDots'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'slim' | 'flat'
  active?: boolean
  width?: number
  loading?: boolean
  Component?: React.ComponentType
}

const Button = forwardRef<HTMLButtonElement, Props>((props, buttonRef) => {
  const {
    className,
    variant = 'flat',
    children,
    active,
    width,
    loading = false,
    disabled = false,
    style = {},
    Component = 'button',
    ...rest
  } = props
  const ref = useRef(null)
  const rootClassName = cn(
    className,
    'bg-white dark:bg-black text-zinc-800 dark:text-zinc-200 cursor-pointer inline-flex px-10 rounded-xs leading-6 shadow-xs font-semibold text-center justify-center uppercase py-4 border items-center hover:bg-gray-200 dark:hover:bg-gray-800 hover:text-black dark:hover:text-white hover:border hover:border-black dark:hover:border-white',
  )
  return (
    <Component
      aria-pressed={active}
      data-variant={variant}
      ref={mergeRefs([ref, buttonRef])}
      className={rootClassName}
      disabled={disabled}
      style={{
        width,
        ...style,
      }}
      {...rest}
    >
      {children}
      {loading && (
        <i className="flex pl-2 m-0">
          <LoadingDots />
        </i>
      )}
    </Component>
  )
})
Button.displayName = 'Button'

export default Button
